import { STORYBLOK_LEGAL_PAGES_ROUTES } from '#shared/constants/storyblok';

export interface UseStoryblokVexatiousClausesProps {
    slug: (typeof STORYBLOK_LEGAL_PAGES_ROUTES)[keyof typeof STORYBLOK_LEGAL_PAGES_ROUTES];
    enabled?: MaybeRefOrGetter<boolean>;
}

export type UseStoryblokVexatiousClausesReturn = Readonly<Ref<string>>;

export const useStoryblokVexatiousClauses = ({ slug, enabled = true }: UseStoryblokVexatiousClausesProps): UseStoryblokVexatiousClausesReturn => {
    const { isDefaultLocale, locale } = useTypedI18n();
    const storyblokApi = useStoryblokApi();
    const key = computed(() => `storyblok-vexatious-${locale.value}-${slug}`);
    const story = computed(() => data.value?.data.story);

    const { data, execute } = useLazyAsyncData(
        key,
        () =>
            storyblokApi.getStory(resolveStoryblokSlug(slug), {
                version: 'published',
                ...(!isDefaultLocale.value ? { language: locale.value } : {}),
            }),
        {
            watch: [locale],
            server: false,
            immediate: false,
        }
    );

    watch(
        () => toValue(enabled),
        value => value && execute(),
        { immediate: true }
    );

    const vexatiousClauses = computed<string>(() => story.value?.content?.vexatiousClauses ?? '');

    return readonly(vexatiousClauses);
};
